<template>
    <div class="category-wrapper">
        <ul class="category">
            <template v-for="subcategory in shownSubCategories" :key="subcategory.name">
                <SubcategoryItem :subcategory="subcategory" :small="false /*isSaleAndDiscountCategory*/" />
            </template>
            <template v-if="totalCategoryCount > categoriesToShow">
                <SubcategoryItem
                    class="cursor-point"
                    :subcategory="{name: $t('listCategory.viewAll'), image: '/nuxt-assets/icons/arrow3.svg'} as CategoryTile"
                    :more-categories-item="true"
                    :small="
                        false // isSaleAndDiscountCategory
                    "
                    tabindex="0"
                    @keydown.enter="showAnotherCategories"
                    @click.prevent="showAnotherCategories"
                />
            </template>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import SubcategoryItem from '~/components/objects/SubcategoryItem.vue'
import CategoryTile from '~/models/Category/CategoryTile'
import BannerTile from '~/models/Category/BannerTile'

const props = defineProps({
    subCategories: {
        type: Array as PropType<CategoryTile[]>,
        required: true,
    },

    isDesktop: {
        type: Boolean,
        default: false,
    },

    banners: {
        type: Array as PropType<BannerTile[]>,
        default: Infinity,
    },

    isSaleAndDiscountCategory: {
        type: Boolean,
        default: false,
    },

    categoriesToShow: {
        type: Number,
        default: 12,
    },
})
const showAnotherCategories = (): void => {
    setTimeout(() => {
        categoriesToShow.value = totalCategoryCount.value
    })
}
const categoriesToShow = ref(props.isDesktop ? 12 : 4)
const totalCategoryCount = ref(props.subCategories.length)
const shownSubCategories = computed(() => {
    return props.subCategories.slice(
        0,
        totalCategoryCount.value > categoriesToShow.value ? categoriesToShow.value - 1 : categoriesToShow.value
    )
})
</script>

<style lang="scss" scoped>
.category__banner {
    grid-row-start: 1;
    grid-row-end: 3;
    overflow: hidden;
    outline: 1px solid $color-grey-dark;
    position: relative;
    display: flex;
    min-height: 180px;
}

.category {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 0;
    gap: 16px;

    @include screen-sm {
        grid-template-columns: repeat(auto-fill, minmax(216px, 1fr));
        //grid-template-rows: repeat(auto-fill, minmax(90px, 1fr));
    }

    &--small {
        @include screen-sm {
            //grid-template-rows: repeat(auto-fill, minmax(60px, 1fr));
        }
    }
}

.category-btn {
    font-size: 14px;
    text-align: center;
    display: block;
    padding: 1em 2em;
    border-radius: 10px;
    color: $color-cta;
    margin-bottom: 1em;
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }

    @include screen-sm {
        display: none;
    }
}
</style>
